import { CommonResponse, TableReponseType, TableRequestType } from '@/types';
import { httpRequest } from '@/utils/request';

export interface GoviewProject {
  id: string;
  projectName: string;
  projectType: number;
  state: number;
  createTime: string;
  createUserId: string;
  isDelete: number;
  indexImage: string;
  remarks: string;
  previewAddress?: string;
  editAddress?: string;
}

export function getGoviewProjectList(data: TableRequestType) {
  return httpRequest<any, CommonResponse<TableReponseType<GoviewProject>>>({
    url: '/api/v1/goview/project/list',
    params: data,
  });
}

export function deleteGoviewProject(ids: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/goview/project/delete',
    method: 'delete',
    data: { ids },
  });
}

export function createGoviewProject(data: { name: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/goview/project/create',
    method: 'post',
    data,
  });
}

